import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import Home from './Home/Home';
import CategoryList from './CategoryList/CategoryList';
import Detail from './Detail/Detail';
import KvIntro from './KvIntro/KvIntro';
import { ROUTE } from '../../../../constants';
import { MsgCountContext } from '../../../../context';
import { fetchMsgCount } from '../../../../api';
import ProjectInfo from './ProjectInfo/ProjectInfo';
import './Content.css';

class Content extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgCount: {},
    };
  }

  // -------------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------------

  componentDidMount() {
    fetchMsgCount()
      .then(msgCount => {
        this.setState({
          msgCount,
        });
      })
      .catch(() => {
        // note - should handle error
      });
  }

  // -------------------------------------------------------------
  // Render
  // -------------------------------------------------------------
  render() {
    const { msgCount } = this.state;
    const { location, match } = this.props;
    const detailActive = location.pathname.indexOf(ROUTE.DETAIL) !== -1;
    const { isExact } = match;

    return (
      <div
        id="content"
        className={`${detailActive ? 'detail' : ''} ${isExact ? 'intro' : ''}`}
      >
        <Home />
        <MsgCountContext.Provider value={msgCount}>
          <Route path={`${ROUTE.CATEGORY}/:id`} component={CategoryList} />
          <Route
            path={`${ROUTE.DETAIL}/:categoryId/:detailId`}
            component={Detail}
          />
          <Route path={ROUTE.ABOUT} component={ProjectInfo} />
        </MsgCountContext.Provider>
        {isExact && <KvIntro />}
      </div>
    );
  }
}

export default withRouter(Content);



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Content.js